module.exports = __webpack_public_path__ + "static/DavidChangResume-f997711b538cf50c17862a00f11cd587.pdf";